// extracted by mini-css-extract-plugin
export default {"popup":"ShareButton_popup__0Sq2T","share":"ShareButton_share__JPq+o"};